import React from 'react'
import { Route, Redirect, } from 'react-router-dom'
import { isAuthenticated } from '../../utils/Session'

/**
 * 检查是否已经登录
 * @param Component
 * @param rest
 * @returns {*}
 * @constructor
 */
const PrivateRoute = ({component: Component, ...rest}) => (
  <Route {...rest} render={(props) => (
    isAuthenticated() == 'true'
      ?
          <Component {...props} />
      : <Component {...props} />
  )}/>
)

export default PrivateRoute


// WEBPACK FOOTER //
// ./src/components/PrivateRoute/index.js